import React, { useState } from 'react';

import Button from '../../ui/button/button';
import { Modal } from '../../ui/modal/modal';
import { ModalBody } from '../../ui/modal/modal-body';

export interface IframeModalBlockProps {
  externalUrl: string;
  buttonLabel: string;
}

const IframeModalBlock = ({
  externalUrl,
  buttonLabel,
}: IframeModalBlockProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  return (
    <>
      <Button onClick={() => setModalOpen(!modalOpen)} className="my-8">
        {buttonLabel}
      </Button>
      <Modal isOpen={modalOpen} handleClose={() => setModalOpen(!modalOpen)}>
        <ModalBody>
          <iframe
            className="h-full w-full border-none"
            src={externalUrl}
          ></iframe>
        </ModalBody>
      </Modal>
    </>
  );
};

export default IframeModalBlock;
